import React, { useState } from "react";

import { useGetDeviceType } from "_common/hooks/global";

import Presentation from "./presentation";

const component = props => {
	const [ selectedImage, setSelectedImage ] = useState ( null );
	const [ modalStatus, setModalStatus ]     = useState ( false );

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	const handleImageModalOpen = () => {
		if ( isMobile )
			return; // designs are not available so didn't open modal

		setModalStatus ( true );
	};

	const handleImageModalClose = () => {
		setModalStatus ( false );
	};

	return (
		<Presentation
			{ ...props }
			handleImageModalClose  = { handleImageModalClose }
			handleImageModalOpen   = { handleImageModalOpen }
			modalStatus            = { modalStatus }
			selectedImage          = { selectedImage }
			setSelectedImage       = { setSelectedImage }
		/>
	);
};

export default component;
